
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.52 18.844a1.63 1.63 0 010 2.226 1.63 1.63 0 01-2.227 0l-4.648-4.687c-1.602 1.055-3.555 1.601-5.664 1.328-3.594-.508-6.485-3.438-6.953-6.992-.664-5.313 3.828-9.805 9.14-9.14 3.555.468 6.485 3.359 6.992 6.952a8.11 8.11 0 01-1.328 5.625l4.688 4.688zM4.075 9.625c0 2.773 2.226 5 5 5 2.734 0 5-2.227 5-5 0-2.734-2.266-5-5-5-2.774 0-5 2.266-5 5z","fill":"#dedede"}})])
          )
        }
      }
    